import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';

export default function LeadModal({ open, onClose }) {
  const [popupType, setPopupType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setPopupType(null);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const fd = new FormData(e.target);
    const type = popupType === 'website' ? 'Website Inquiry' : 'App Inquiry';
    emailjs
      .send(
        'service_3d5bhy6',
        'template_3qdot7l',
        {
          name: fd.get('name'),
          email: fd.get('email'),
          phone: fd.get('phone'),
          company: fd.get('company') || '',
          type,
          requirements: popupType === 'website' ? fd.get('requirements') : '',
          message: `New ${type} from ${fd.get('name')}`,
        },
        '0hws8bYSoW3KWfjU-'
      )
      .then(() => {
        toast.success('Thank you! Our team will reach you soon.');
        handleClose();
      })
      .catch(() => toast.error('Something went wrong. Please try again.'))
      .finally(() => setIsSubmitting(false));
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            className="relative w-full max-w-md rounded-2xl border border-white/10 bg-card p-6 sm:p-8"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={handleClose}
              className="absolute right-4 top-4 text-faint hover:text-white"
            >
              ×
            </button>
            {!popupType ? (
              <>
                <h3 className="text-2xl font-bold text-white">Get Started</h3>
                <p className="mt-2 text-sm text-mute">How should customers shop with you?</p>
                <div className="mt-6 grid gap-3">
                  <button
                    type="button"
                    onClick={() => setPopupType('website')}
                    className="rounded-2xl border border-white/10 bg-black px-4 py-4 text-left hover:border-accent/40"
                  >
                    <span className="font-semibold text-white">Website store</span>
                    <span className="mt-1 block text-sm text-mute">Branded site for your catalogue</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setPopupType('app')}
                    className="rounded-2xl border border-white/10 bg-black px-4 py-4 text-left hover:border-accent/40"
                  >
                    <span className="font-semibold text-white">Mobile app</span>
                    <span className="mt-1 block text-sm text-mute">Your brand on the home screen</span>
                  </button>
                </div>
              </>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-3">
                <button type="button" onClick={() => setPopupType(null)} className="text-xs text-accent">
                  ← Back
                </button>
                <h3 className="text-xl font-bold text-white">
                  {popupType === 'website' ? 'Website inquiry' : 'App inquiry'}
                </h3>
                <input required name="name" placeholder="Name" className="w-full rounded-xl border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-accent" />
                <input required type="email" name="email" placeholder="Email" className="w-full rounded-xl border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-accent" />
                <input required name="phone" placeholder="Phone" className="w-full rounded-xl border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-accent" />
                <input name="company" placeholder="Shop / company (optional)" className="w-full rounded-xl border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-accent" />
                {popupType === 'website' && (
                  <textarea name="requirements" rows={3} placeholder="Tell us about your shops" className="w-full resize-none rounded-xl border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-accent" />
                )}
                <button type="submit" disabled={isSubmitting} className="btn-grad w-full">
                  {isSubmitting ? 'Submitting…' : 'Submit'}
                </button>
              </form>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
